var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWithdraw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-2h20v20H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 10a1 1 0 0 1 1 1v5H0v-5a1 1 0 0 1 2 0v3h14v-3a1 1 0 0 1 1-1zM5.707 6.12a.999.999 0 1 1-1.414-1.414L9 0l4.707 4.707a.999.999 0 1 1-1.414 1.414L10 3.828v6.586a1 1 0 0 1-2 0V3.828L5.707 6.121z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWithdraw);
export default __webpack_public_path__ + "static/media/icon-withdraw.e8a8c1d0c9b98e9539f01a4400a4bab4.svg";
export { ForwardRef as ReactComponent };